import { promptWithoutVideoThumbnails } from "@ui/organisms/QuestionBox/promptMentionSerialization";
import type { QuestionEffort } from "@ui/organisms/QuestionBox/questionEfforts";
import { askPublicAskPageQuestion } from "@/client";
import { type AskFailure, askFailure } from "~/modules/shared/chat/askFailure";
import { parseAskPageAskError } from "./askPageAskErrors";

export type AskPageQuestionResult =
	| { ok: true; id: string; path: string }
	| (AskFailure & {
			/** Laravel's per-field messages, on a 422. */
			errors?: Record<string, string[]>;
	  });

/**
 * Asks a question on a creator's AskPage, or a follow-up in a thread when
 * `threadRootId` is given. Never throws: every outcome is a result.
 */
export async function postAskPageQuestion(options: {
	handle: string;
	prompt: string;
	threadRootId?: string;
	effort?: QuestionEffort;
}): Promise<AskPageQuestionResult> {
	let result: Awaited<ReturnType<typeof askPublicAskPageQuestion>>;
	try {
		result = await askPublicAskPageQuestion({
			path: { handle: options.handle },
			body: {
				prompt: promptWithoutVideoThumbnails(options.prompt),
				...(options.effort ? { effort: options.effort } : {}),
				...(options.threadRootId
					? { thread_root_id: options.threadRootId }
					: {}),
			},
		});
	} catch {
		return { ok: false };
	}

	const data = result.data as { id?: string; path?: string } | undefined;
	if (data?.id && data.path) {
		return { ok: true, id: data.id, path: data.path };
	}

	return {
		...askFailure(result.error, result.response),
		errors: parseAskPageAskError(result.error)?.errors,
	};
}
